import { isResponseOk, useFetch } from "@swa-ui/fetch";

export const useMissingInformationServices = () => {
  const { loading, put, response } = useFetch("/api/security/v3/security/customers");

  return {
    loading,
    saveMissingInformation,
  };

  async function saveMissingInformation(missingFormData) {
    const NON_DIGITS_REGEX = /\D/g;
    const EMPTY_STRING = "";

    let callStatus = { ok: true };

    const body = await put("missing-information", {
      ...(missingFormData.email && { email: missingFormData.email }),
      ...(missingFormData.phoneNumber && {
        phone: {
          countryCode: missingFormData.phoneCountryCode,
          number: missingFormData.phoneNumber.replace(NON_DIGITS_REGEX, EMPTY_STRING),
          phoneType: missingFormData.phoneType,
          primary: true,
        },
      }),
      ...(missingFormData.username && { username: missingFormData.username }),
      ...(missingFormData.answer1 && {
        securityQuestions: [
          {
            answer: missingFormData.answer1,
            question: missingFormData.question1,
          },
          {
            answer: missingFormData.answer2,
            question: missingFormData.question2,
          },
        ],
      }),
    });

    callStatus.unsavedInformation = body.missingInformation ?? null;

    if (!isResponseOk(response)) {
      callStatus = { errorCode: body.code, ok: false };
    }

    return { callStatus };
  }
};
